// extracted by mini-css-extract-plugin
export default {"brandsSwiper":"brands_brandsSwiper__TQMk+","brands":"brands_brands__9WRim"};